import { Box, Stack, Typography } from '@mui/material';

import { radius } from '@karehero/llama/theme/radius';

import StatusBar from '@/designs-dev/device/StatusBar';
import HomeIndicator from '@/designs-dev/device/HomeIndicator';
import ScreenRoot from '@/components/wrapped/ScreenRoot';
import { CALCULATOR } from '@/karehero-app/tell-us-once/intake/content';

// A hole in the flow, drawn as one. The calculator is not designed here, and a
// screen that looks finished would read as a decision rather than a gap.
const CalculatorScreen = ({ onNext }: { onNext: () => void }) => (
  <ScreenRoot sx={{ bgcolor: 'custom.neutral.300' }}>
    <StatusBar />

    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
      }}
    >
      <Stack
        onClick={onNext}
        sx={{
          width: '100%',
          p: 3,
          textAlign: 'center',
          border: 1,
          borderStyle: 'dashed',
          borderColor: 'custom.neutral.500',
          borderRadius: `${radius.md}px`,
          cursor: 'pointer',
        }}
        spacing={1}
      >
        <Typography sx={{ color: 'text.secondary' }} variant='overline'>
          Placeholder
        </Typography>
        <Typography variant='h2'>{CALCULATOR.title}</Typography>
        <Typography sx={{ color: 'text.secondary' }} variant='body2'>
          {CALCULATOR.note}
        </Typography>
      </Stack>
    </Box>

    <HomeIndicator />
  </ScreenRoot>
);

export default CalculatorScreen;
